const LOCALSTORAGE = Object.freeze({
    TOKEN: 'token_localfarm',
    AUTH: 'auth_localfarm',
});

export default LOCALSTORAGE;
